/*
jQuery(function($){
    if (window.matchMedia("(min-width: 992px)").matches) {

    $('body').on('mouseenter mouseleave', '.dropdown', function (e) {
    var dropdown = $(e.target).closest('.dropdown');
    var menu = $('.dropdown-menu', dropdown);
    dropdown.addClass('show');
    menu.addClass('show');
    setTimeout(function () {
        dropdown[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
        menu[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
    }, 300);
    });
    }
    else {
        $('#main-menu .dropdown-toggle').on("click", function() {
            $(this).next().slideToggle();
            });
    }

});

*/

jQuery(function($) {

    if ($(window).width() < 992) {
      $(".dropdown-toggle").attr('data-toggle', 'dropdown').attr('data-bs-toggle', 'dropdown').attr('href', '#').removeAttr('data-hover').removeAttr('data-bs-hover');
    } else {
      $(".dropdown-toggle").removeAttr('data-toggle').removeAttr('data-bs-toggle');
    }
    
    var timer = '';
    $(window).resize(function() {
  
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function(){
  
      if ($(window).width() < 992) {
        $(".dropdown-toggle").attr('data-toggle', 'dropdown').attr('data-bs-toggle', 'dropdown').attr('href', '#').removeAttr('data-hover').removeAttr('data-bs-hover');
      } else {
        $(".dropdown-toggle").removeAttr('data-toggle').removeAttr('data-bs-toggle');
      }
    }, 200);
    });
  });